import { InjectionToken } from '@angular/core';
import { AccountRealm } from '@shared/models/account-realm.model';

export const ACCOUNT_REALM = new InjectionToken<AccountRealm>('ACCOUNT_REALM', {
  providedIn: 'root',
  factory: () => 'administration',
});
